export default {
  title: "Shoppings"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5010: { text: "Ocurrió un error en el catálogo de Shoppings" }
    , WS5010: { text: "Ocurrió un error en el catálogo de Shoppings" }
    , JS5010: { text: "Ocurrió un error en el catálogo de Shoppings" }
    , CR5010: { text: "Ocurrió un error en el catálogo de Shoppings" }
    , UK_Shoppings: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/shoppings.js